var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C9.66 18.5 7.75 16.59 7.75 14.25C7.75 13.84 8.09 13.5 8.5 13.5C8.91 13.5 9.25 13.84 9.25 14.25C9.25 15.77 10.48 17 12 17C13.52 17 14.75 15.77 14.75 14.25C14.75 13.84 15.09 13.5 15.5 13.5C15.91 13.5 16.25 13.84 16.25 14.25C16.25 16.59 14.34 18.5 12 18.5Z",
    fill: "#494C50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18988 6.38C4.99988 6.38 4.79988 6.3 4.65988 6.16C4.36988 5.87 4.36988 5.39 4.65988 5.1L8.28988 1.47C8.57988 1.18 9.05988 1.18 9.34988 1.47C9.63988 1.76 9.63988 2.24 9.34988 2.53L5.71988 6.16C5.56988 6.3 5.37988 6.38 5.18988 6.38Z",
    fill: "#494C50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8101 6.38C18.6201 6.38 18.4301 6.31 18.2801 6.16L14.6501 2.53C14.3601 2.24 14.3601 1.76 14.6501 1.47C14.9401 1.18 15.4201 1.18 15.7101 1.47L19.3401 5.1C19.6301 5.39 19.6301 5.87 19.3401 6.16C19.2001 6.3 19.0001 6.38 18.8101 6.38Z",
    fill: "#494C50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.21 10.6C20.14 10.6 20.07 10.6 20 10.6H19.77H4C3.3 10.61 2.5 10.61 1.92 10.03C1.46 9.58001 1.25 8.88001 1.25 7.85001C1.25 5.10001 3.26 5.10001 4.22 5.10001H19.78C20.74 5.10001 22.75 5.10001 22.75 7.85001C22.75 8.89001 22.54 9.58001 22.08 10.03C21.56 10.55 20.86 10.6 20.21 10.6ZM4.22 9.10001H20.01C20.46 9.11001 20.88 9.11001 21.02 8.97001C21.09 8.90001 21.24 8.66001 21.24 7.85001C21.24 6.72001 20.96 6.60001 19.77 6.60001H4.22C3.03 6.60001 2.75 6.72001 2.75 7.85001C2.75 8.66001 2.91 8.90001 2.97 8.97001C3.11 9.10001 3.54 9.10001 3.98 9.10001H4.22Z",
    fill: "#494C50"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8902 22.75H8.86024C5.28024 22.75 4.48024 20.62 4.17024 18.77L2.76024 10.12C2.69024 9.71 2.97024 9.33 3.38024 9.26C3.78024 9.19 4.17024 9.47 4.24024 9.88L5.65024 18.52C5.94024 20.29 6.54024 21.25 8.86024 21.25H14.8902C17.4602 21.25 17.7502 20.35 18.0802 18.61L19.7602 9.86C19.8402 9.45 20.2302 9.18 20.6402 9.27C21.0502 9.35 21.3102 9.74 21.2302 10.15L19.5502 18.9C19.1602 20.93 18.5102 22.75 14.8902 22.75Z",
    fill: "#494C50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.ff0dfc008f50978bb522b31e1aa03795.svg";
export { ForwardRef as ReactComponent };